import { Button, Col, Form, Input, Modal, Row, Select, Space } from 'antd';
import { useEffect, useState } from 'react';
import { User } from '../../modules/auth';
import { getEnterpriseMemberList } from '../../api/constlink';

const { Option } = Select;

interface CreateTaxInvoiceAccountModalProps {
  openTaxInvoiceAccountModal: boolean;
  enterpriseId: string;
  onCreateTaxInvoiceAccount: (data: any) => void;
  onCancel: () => void;
}

function CreateTaxInvoiceAccountModal({
  openTaxInvoiceAccountModal,
  enterpriseId,
  onCreateTaxInvoiceAccount,
  onCancel,
}: CreateTaxInvoiceAccountModalProps) {
  const [form] = Form.useForm();

  const [taxInvoiceAccountManagers, setTaxInvoiceAccountManagers] =
    useState<User[]>();

  useEffect(() => {
    (async () => {
      const data = await getEnterpriseMemberList({ enterpriseId });
      console.log(data);
      setTaxInvoiceAccountManagers(data);
    })();
  }, [enterpriseId]);

  return (
    <>
      <Modal
        open={openTaxInvoiceAccountModal}
        title="홈택스 연동"
        onCancel={onCancel}
        footer={null}
      >
        <>
          <Form
            form={form}
            name="requestAuthCode"
            layout="vertical"
            onFinish={onCreateTaxInvoiceAccount}
            initialValues={{
              type: '0',
            }}
          >
            <Row justify="center">
              <Col span={18}>
                <Form.Item
                  name="userName"
                  label="홈택스 아이디"
                  style={{ width: '60%' }}
                  rules={[
                    { required: true, message: '홈택스 아이디를 입력하세요.' },
                  ]}
                >
                  <Input placeholder="아이디" />
                </Form.Item>
              </Col>
            </Row>
            <Row justify="center">
              <Col span={18}>
                <Form.Item
                  name="userPassword"
                  label="홈택스 비밀번호"
                  style={{ width: '60%' }}
                  rules={[
                    {
                      required: true,
                      message: '홈택스 비밀번호를 입력하세요.',
                    },
                  ]}
                >
                  <Input.Password placeholder="비밀번호" />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="center">
              <Col span={18}>
                <Form.Item
                  name="user"
                  label="담당자"
                  rules={[
                    {
                      required: true,
                      message: '담당자를 설정 해 주세요.',
                    },
                  ]}
                >
                  <Select
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="담당자를 입력 하세요."
                  >
                    {taxInvoiceAccountManagers?.map(
                      (taxInvoiceAccountManager) => (
                        <Option
                          key={taxInvoiceAccountManager.id}
                          value={taxInvoiceAccountManager.id}
                        >
                          {taxInvoiceAccountManager.name} (
                          {taxInvoiceAccountManager.myEnterprise.name})
                        </Option>
                      ),
                    )}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row justify="center">
              <Col span={18}>
                <Form.Item
                  name="type"
                  label="사용방식"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select allowClear placeholder="사용방식을 선택 하세요.">
                    <Option value="0">홈택스 자료로 매입증빙 하기</Option>
                    <Option value="1">홈택스 자료로 지출등록하기</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row justify="center">
              <Form.Item>
                <Space size="middle">
                  <Button
                    htmlType="submit"
                    type="primary"
                    disabled={
                      form
                        .getFieldsError()
                        .filter(({ errors }) => errors.length).length > 0
                    }
                  >
                    홈택스 연동하기
                  </Button>
                </Space>
              </Form.Item>
            </Row>
          </Form>
        </>
      </Modal>
    </>
  );
}

export default CreateTaxInvoiceAccountModal;
